// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { init as initApm } from '@elastic/apm-rum';
import Store, { persistor } from './store/Store';

import App from './App';
import packageJson from '../package.json';
import reportWebVitals from './reportWebVitals';
import { register as registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Helper to check if URL belongs to APM
const isApmRequest = (url) => {
  const apmUrl = window.CONFIG?.ERROR_LOGGER;
  return apmUrl && url?.toString()?.includes(apmUrl);
};

// Override fetch for APM to use low priority
const originalFetch = window.fetch;
window.fetch = function (...args) {
  const [url, options = {}] = args;

  // Set low priority for APM requests
  if (isApmRequest(url)) {
    return originalFetch(url, {
      ...options,
      priority: 'low', // Set APM requests to low priority
      keepalive: import.meta.env.MODE === 'production', // Allow request to outlive page
    });
  }

  return originalFetch(...args);
};
try {
  const apm = initApm({
    serviceName: `${packageJson.name}-${window.CONFIG.ENV}`,

    serverUrl: `${window.CONFIG.ERROR_LOGGER}`,

    // Set service version (required for sourcemap feature)
    serviceVersion: packageJson.version,
    environment: window.CONFIG.ENV,
    active: import.meta.env.MODE === 'production',
    distributedTracingOrigins: [`${window.location.pathname}`],
    logLevel: 'warn', // Change to debug mode for better troubleshooting
    transactionSampleRate: 1.0,

    instrument: true, // Enable auto-instrumentation
  });
  window.apm = apm;
} catch {
  // Do nothing
}

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Service worker registration
registerServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
